module.exports = __webpack_public_path__ + "img/icon-quac-large_blanco.e3b9eb4b.svg";